import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LibraryMode, LibraryView, readLibraryParams, writeLibraryParams } from "./libraryFilterParams";

/** The library's filters and Only mine, kept in the URL so reload, Back, and shared links land on the same view. */
export function useLibraryView(mode: LibraryMode) {
  const history = useHistory();
  const location = useLocation();
  const view = React.useMemo(() => readLibraryParams(location.search, mode), [location.search, mode]);

  // Reads the live location, so two updates in one tick both land.
  const update = React.useCallback(
    (change: Partial<LibraryView> | ((current: LibraryView) => Partial<LibraryView>)) => {
      const current = readLibraryParams(history.location.search, mode);
      const next = { ...current, ...(typeof change === "function" ? change(current) : change) };
      history.replace({ ...history.location, search: writeLibraryParams(history.location.search, next, mode) });
    },
    [history, mode]
  );

  return { ...view, update };
}
